import { useNavigate, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export const CtaBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goContact = () => {
    if (location.pathname !== "/") navigate("/#contact");
    else {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-20 bg-[#10193f]" data-testid="cta-banner">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <h2 className="font-heading text-3xl sm:text-4xl font-black text-white">
          Need Survey Grade Drone Services?
        </h2>
        <p className="mt-4 text-lg text-white/70">
          Get a proposal within 24 hours from our project team.
        </p>
        <Button
          data-testid="cta-banner-btn"
          onClick={goContact}
          className="mt-8 rounded-sm bg-white text-[#10193f] hover:bg-[#e8ebf1] font-semibold h-12 px-8 text-base"
        >
          Request Free Quote <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};
